import { API_PATH_PREFIX } from '@/services/vehicleDiagnosticsApi';

/**
 * To be used for all the dialogs that will be opened in the parent frontend.
 * The parent frontend (web-workshop) uses this same value to process Dialog related messages.
 * */
export const MFE_DIALOG_PREFIX = 'VEHICLE-DIAGNOSTICS-DIALOGS';

export const WORKSHOPS_ENDPOINT_PATH = `${API_PATH_PREFIX}/workshops`;
export const ASSIGNMENTS_ENDPOINT_PATH = `${API_PATH_PREFIX}/assignments`;

export const WORKSHOPS_DIALOG_PATH = '/dialog/workshop-details';
export const ASSIGNMENTS_DIALOG_PATH = '/dialog/customer-details';
